import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../../feature-core/wf/interface/wf-activity-registry';
import {
    PmCreatePersonWfProcessStepActivityComponent
} from './component/protected-components/wf/pm-create-person-wf-process-step-activity/pm-create-person-wf-process-step-activity.component';

export const PM_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['module_activity:pm.Person', {mainComponent: PmCreatePersonWfProcessStepActivityComponent}],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
